import { render, staticRenderFns } from "./BoletaPage.vue?vue&type=template&id=2b7eac48&scoped=true&"
import script from "./BoletaPage.vue?vue&type=script&lang=js&"
export * from "./BoletaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7eac48",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/BoletaPage.vue
// module id = 206
// module chunks = 28